import React from 'react';

import BillingCycleConfigurator from '~/components/logic/payments/BillingCycleConfigurator';

import useAccountId from '~/hooks/useAccountId';



const BillingCycleConfiguratorSection: React.FC = () => {
	const accountId = useAccountId();

	if (accountId === null) {
		return null;
	}

	return (
		<BillingCycleConfigurator
			accountId={accountId}
		/>
	);
};



export default BillingCycleConfiguratorSection;
